module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "c01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }), _c('em', [_vm._v("Kelsey’s Cranberry Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Kelsey Adams is one of those remarkable young ladies who is power-packed with giftedness. She coaches, she teaches, she creates, and she even cooks! Here is her fun and fruity salsa recipe — you’re going to love this.")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "center1"
  }, [_c('em', [_vm._v("12 ounces fresh or frozen cranberries, chopped")]), _c('br'), _c('em', [_vm._v("1 Granny Smith apple, cored and chopped")]), _c('br'), _c('em', [_vm._v("½ red bell pepper, seeded and chopped")]), _c('br'), _c('em', [_vm._v("½ medium red onion, chopped")]), _c('br'), _c('em', [_vm._v("3 tablespoons chopped fresh cilantro")]), _c('br'), _c('em', [_vm._v("2 tablespoons pickled jalapeño peppers")]), _c('br'), _c('em', [_vm._v("¾ cup sugar")]), _c('br'), _vm._v("⅓ "), _c('em', [_vm._v("cup apple juice")]), _c('br'), _c('em', [_vm._v("Tortilla chips, for serving")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Mix all the ingredients, except for the tortilla chips, in a medium bowl. Cover and refrigerate overnight. Serve with tortilla chips of your choice. This will keep in the refrigerator for 2 weeks.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Makes about 4 cups")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9781449400217_2.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4704e4e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781449400217_epub_c01_r1.vue
// module id = 87
// module chunks = 0